export default "Gymnases et complexes sportifs : grand volume, hauteur sous plafond. Décret tertiaire, primes CEE et plan d'actions pour les collectivités.";
